import React, { Component, Fragment } from "react"
import Async from "react-select"
import Field from "../../Common/Field/Field"
import ModuleHeader from "../ModuleHeader"
import Button from "../../Buttons/Button"
import TimerModule from "../TimerModule"
import ButtonIcon from "../../Costing/Button/ButtonIcon"

const patternTemplate = {
  assignedTo: "",
  masterName: "",
  type: "",
  blockRef: "",
  trial: true,
  status: "",
  ETA: "",
  completedDate: ""
}

const timeTemplate = {
  in: "",
  out: "",
  break: "",
  reason: ""
}
export default class PatternModule extends Component {
  state = {
    pattern: this.props.pattern,
    disabled: false,
    toggle: true,
    patternCount: [patternTemplate],
    timeCount: [timeTemplate],
    assignedToList: [],
    STATUS: [],
    PATTERN: {},
    durationPatterns: null
  }

  componentWillMount() {
    const {
      _id,
      pattern,
      assignedToList,
      disabled,
      STATUS,
      PATTERNTYPE,
      patternProcess,
      durationPatterns
    } = this.props
    this.setState({
      _id,
      pattern,
      patternProcess,
      assignedToList,
      disabled,
      STATUS,
      PATTERNTYPE,
      durationPatterns
    })
    //console.log(this.props,"propspatt")
  }

  componentWillReceiveProps(nextProps) {
    const {
      _id,
      pattern,
      assignedToList,
      disabled,
      STATUS,
      PATTERNTYPE,
      patternProcess,
      durationPatterns
    } = nextProps
    this.setState({
      _id,
      pattern,
      patternProcess,
      assignedToList,
      disabled,
      STATUS,
      PATTERNTYPE,
      durationPatterns
    })
  }

  render() {
    const { pattern, STATUS, assignedToList } = this.state
    const { permissions } = this.props
    return (
      <div class="card-filter" id="pattern" style={{ marginBottom: ".5%" }}>
        <div class="col-md-12">
          <ModuleHeader
            header={"Pattern "}
            durationETA={this.state.durationPatterns}
            onClick={this.onOpenModal}
            _id={this.state._id}
            moduleName={"pattern"}
            disabled={this.state.disabled}
            process={this.state.patternProcess}
            updateModulesMain={this.props.updateModulesMain}
            statusList={STATUS}
            measurementModal={true}
            customer={this.props.customer}
            customerDepartmentId={this.props.customerDepartmentId}
            type={this.props.type}
            magnumStyleId = {this.props.magnumStyleId}
          />
          <div class="col-md-12" style={{ paddingBottom: "1%" }}>
            <form name="patternForm">
              <div class="wash-container">
                <div class="col-md-12 no-padding">
                  <div class="col-md-12 nopadding">
                    <table class="table">
                      <thead class="border-bottom-0">
                        <tr class="border-bottom-0">
                          {/* <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Assigned to
                            </th> */}
                          <th
                            class="border-bottom-0 text-left"
                            width="11.1111111111%"
                          >
                            Pattern Master Name
                          </th>
                          <th
                            class="border-bottom-0 text-left"
                            width="11.1111111111%"
                          >
                            Pattern type
                          </th>
                          <th
                            class="border-bottom-0 text-left"
                            width="11.1111111111%"
                          >
                            Block Ref used
                          </th>
                          <th
                            class="border-bottom-0 text-left"
                            width="11.1111111111%"
                          >
                            Trial Required
                          </th>
                          <th
                            class="border-bottom-0 text-left"
                            width="11.1111111111%"
                          >
                           Approval Status
                          </th>
                          {/* <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Status
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              ETA Date
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Completed Date
                            </th> */}
                          <th
                            class="border-bottom-0 text-left"
                            width="11.1111111111%"
                          />
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {/* <td class="border-top-0">
                            <div class="custom-async-select">
                              <Async
                                name="assignedTo"
                                value={pattern.assignedTo}
                                // onInputChange={this.getDoneBy}
                                // onChange={e =>
                                //   this.changeAssignedTo(e, "patternAssignedTo")
                                // }
                                placeholder="Find Assigned To"
                                options={this.state.assignedToList}
                                disabled ={true}
                              />
                              </div>
                            </td> */}
                          <td class="border-top-0">
                            <div class="custom-async-select">
                              <Async
                                name="patternMaster"
                                value={pattern.patternMaster}
                                // onInputChange={e =>
                                //   this.getPatternMaster(e, "patternMaster")
                                // }
                                onChange={value =>
                                  this.props.updatePattern(
                                    "patternMaster",
                                    value.value
                                  )
                                }
                                placeholder="Find Pattern Master "
                                options={assignedToList}
                                disabled={this.state.disabled}
                              />
                            </div>
                          </td>
                          <td class="border-top-0">
                            <Field
                              isFormGroup={false}
                              inputType="select"
                              inputName="patternType"
                              value={pattern.patternType}
                              options={this.state.PATTERNTYPE || []}
                              onChange={this.props.updatePattern}
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td class="border-top-0">
                            <Field
                              isFormGroup={false}
                              inputType="text"
                              inputName="blockRefNumber"
                              value={pattern.blockRefNumber}
                              onChange={this.props.updatePattern}
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td class="border-top-0 text-left">
                            <Field
                              isFormGroup={false}
                              inputType="checkboxToggle"
                              inputName="trailRequired"
                              value={pattern.trailRequired}
                              onChange={this.props.updatePattern}
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td class="border-top-0 text-left">
                            <Field
                              isFormGroup={false}
                              inputType="select"
                              inputName="approvalStatus"
                              value={pattern.approvalStatus}
                              options={[
                                {
                                  label: "approved",
                                  value: "approved"
                                },
                                {
                                  label: "pending",
                                  value: "pending"
                                },
                                {
                                  label: "rejected",
                                  value: "rejected"
                                }
                              ]}
                              // index={index}
                              onChange={this.props.updatePattern}
                              disabled={this.state.disabled}
                            />
                          </td>
                          {/* <td class="border-top-0">
                                <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="status"
                                    value={pattern.status}
                                    options={this.state.STATUS}
                                    onChange={this.props.updatePattern}
                                    index ={index}
                                    disabled={this.state.disabled}
                                />
                            </td>
                            <td class="border-top-0">
                              <Field
                                isFormGroup={false}
                                inputType="date"
                                value={pattern.ETA}
                                inputName="ETA"
                                onChange={this.props.updatePattern}
                                index ={index}
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td class="border-top-0">
                              <Field
                                isFormGroup={false}
                                inputType="date"
                                value={pattern.completedDate}
                                inputName="completedDate"
                                index ={index}
                                onChange={this.props.updatePattern}
                                index ={index}
                                disabled={this.state.disabled}
                              />
                            </td> */}
                          <td class="border-top-0">
                            {/* <a
                                className={
                                  index === 0
                                    ? "btn-floating btn-small waves-effect waves-light green pull-right"
                                    : "btn-floating btn-small waves-effect waves-light red pull-right del-tr-btn"
                                }
                                onClick={e =>
                                 index == 0 ?  this.addPattern() : this.removePattern(index)
                                }
                              >
                                <i class="material-icons">
                                  {index === 0 ? "add" : "clear"}
                                </i>
                              </a> */}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="col-md-12">
                    <div
                      className="inline-center"
                      style={{ width: "7%", padding: "5px" }}
                    >
                      <label>Logs</label>
                      {!this.state.disabled &&
                        (permissions.create || permissions.edit) && (
                          <ButtonIcon
                            buttonType="add"
                            addRemoveFunc={() => this.props.addPatternLog()}
                          />
                        )}
                    </div>
                  </div>
                  {pattern.logs.map((log, i) => {
                    return (
                      <div class="col-md-12 no-padding" key={i}>
                        <TimerModule
                          time={log.timeIn}
                          buttonName={"time in"}
                          updatePatternCheck={() =>
                            this.props.updatePatternCheck("timeIn", i)
                          }
                          disabled={this.state.disabled}
                        />
                        <TimerModule
                          time={log.timeOut}
                          buttonName={"time out"}
                          updatePatternCheck={() =>
                            this.props.updatePatternCheck("timeOut", i)
                          }
                          disabled={this.state.disabled}
                        />
                        <div class="col-md-2 step-one pl-0">
                          <Field
                            isFormGroup={true}
                            inputType="time"
                            maxlength={23}
                            inputName="breakTime"
                            label="Break Time (Duration)"
                            value={log.breakTime}
                            onChange={(name, value) =>
                              this.props.updatePatternLog(name, value, i)
                            }
                            disabled={this.state.disabled}
                          />
                        </div>
                        <div class="col-md-2 step-one pl-0">
                          <Field
                            isFormGroup={true}
                            inputType="text"
                            inputName="reason"
                            label="Reason"
                            value={log.reason}
                            onChange={(name, value) =>
                              this.props.updatePatternLog(name, value, i)
                            }
                            disabled={this.state.disabled}
                          />
                        </div>
                        <div class="col-md-1 step-one pl-0">
                          {!this.state.disabled &&
                            (permissions.create || permissions.edit) && (
                              <ButtonIcon
                                buttonType="clear"
                                addRemoveFunc={() =>
                                  this.props.removePatternLog(i)
                                }
                              />
                            )}
                        </div>
                      </div>
                    )
                  })}
                  <div class="col-md-12 no-padding">
                    <div class="col-md-10 step-one pl-0">
                      <Field
                        isFormGroup={true}
                        inputType="textarea"
                        inputName="comment"
                        value={pattern.comment}
                        label="comments"
                        onChange={this.props.updatePattern}
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            {!this.state.disabled && (permissions.create || permissions.edit) && (
              <div class="col-md-12 no-padding text-center profile-btn">
                <Button
                  buttonName={"save"}
                  onClick={e => this.props.createPattern(e)}
                />
                <Button
                  buttonName={"Complete"}
                  onClick={e => this.props.completePattern(e)}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/PatternModule/index.js